import { createApiRef, useApiHolder } from '@backstage/core-plugin-api';

import type { DeriveMeasurementNameExtensionOptions } from './types';

export interface DeriveMeasurementNameExtensionsApi {
  getExtension(): DeriveMeasurementNameExtensionOptions | undefined;
}

export const deriveMeasurementNameExtensionsApiRef =
  createApiRef<DeriveMeasurementNameExtensionsApi>({
    id: 'plugin.confidence-metrics.derive-measurement-name-extension',
  });

export const useDeriveMeasurementNameExtension = ():
  | DeriveMeasurementNameExtensionOptions
  | undefined => {
  const apis = useApiHolder();
  const api = apis.get(deriveMeasurementNameExtensionsApiRef);
  return api?.getExtension();
};
